import {
    MongoBadge,
    PythonBadge,
    ReactBadge
} from '../components/Projects/TechBadges'
import { FiGithub, FiLink, FiPlay } from 'react-icons/fi'
import { ProjectT } from './types'

export const projectData: ProjectT[] = [
    {
        name: 'Lyravue AI App',
        id: 'lyravue',
        type: 'Mobile app',
        tagline: 'AI powered image generation app.',
        tags: [<PythonBadge />, <MongoBadge />, <ReactBadge />],
        imageSrc: '/lyravue.webp',
        description:
            'Transform your favorite songs into stunning visual art with AI. Lyravue analyzes lyrics, rhythm, and melody to create unique, breathtaking visuals—because music isn’t just heard, it’s seen.',
        links: [
            {
                link: 'https://play.google.com/store/apps/details?id=com.veucci.lyravue',
                icon: <FiPlay />,
            },
        ],
        headerLink: 'https://play.google.com/store/apps/details?id=com.veucci.lyravue',
    },
    {
        name: 'Turkish Lyrics Genre Classification Model',
        id: 'turkishmodel',
        type: 'AI Model',
        tagline: 'Turkish Lyrics Genre Classification Model',
        tags: [<PythonBadge />],
        imageSrc: '/turkish-lyric-to-genre.webp',
        description:
            "The model was trained using the BERT language model on my song lyrics dataset to predict the genre of a given song based on its lyrics.",
        links: [
            {
                link: 'https://github.com/Veucci/turkish-lyric-to-genre',
                icon: <FiGithub />,
            },
        ],
        headerLink: 'https://github.com/Veucci/turkish-lyric-to-genre',
    },
    {
        name: 'Lyrics Genre Classification Model',
        id: 'lyricsmodel',
        type: 'AI Model',
        tagline: 'Lyrics Genre Classification Model',
        tags: [<PythonBadge />],
        imageSrc: '/lyrics-to-genre.webp',
        description:
            "The model was trained using the BERT language model on my song lyrics dataset to predict the genre of a given song based on its lyrics.",
        links: [
            {
                link: 'https://github.com/Veucci/lyrics-to-genre',
                icon: <FiGithub />,
            },
        ],
        headerLink: 'https://github.com/Veucci/lyrics-to-genre',
    },
    {
        name: 'Turkish Retr0 TV',
        id: 'tv',
        type: 'Web app',
        tagline: 'A retro tv webapp for nostalgia.',
        tags: [<PythonBadge />, <MongoBadge />],
        imageSrc: '/tv.webp',
        description:
            'A retro TV web app that brings nostalgia to life, letting you relive classic moments.',
        links: [
            {
                link: 'https://retrotv.efe-ozkan.online',
                icon: <FiLink />,
            },
        ],
        headerLink: 'https://retrotv.efe-ozkan.online',
    }
]
